import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import SortableTree from '@nosferatu500/react-sortable-tree';
import './style/node-content-renderer.sass';
import './style/tree-node.sass';
import '@nosferatu500/react-sortable-tree/style.css';
import { HTML5Backend } from 'react-dnd-html5-backend';
// FIXME: touch event's does not supported by library. Need fork
export const isTouchDevice = !!('ontouchstart' in window || navigator.maxTouchPoints);
export const dndBackend = isTouchDevice ? TouchBackend : HTML5Backend;
export const optionsForBackend = isTouchDevice
    ? {
        delay: 400,
        // delayTouchStart: 300,
        // enableMouseEvents: true,
        // enableTouchEvents: true,
        // ignoreContextMenu: true,
    }
    : {};
export const Tree = memo(function Tree(props) {
    return isTouchDevice ? (
    // <DndProvider backend={dndBackend} options={optionsForBackend}>
    _jsx(DndProvider, { backend: TouchBackend, options: optionsForBackend, children: _jsx("div", { className: "tree", children: _jsx(SortableTree, { slideRegionSize: 10, ...props }) }) })) : (_jsx("div", { className: "tree", children: _jsx(SortableTree, { slideRegionSize: 10, ...props }) }));
});
